import React, { Fragment } from 'react';
import Collections from './Collections';
import MainFooter from '../nav/MainFooter';
import TopNav from '../nav/TopNav';
import ApparelNav from './ApparelNav';
import { Container } from 'react-bootstrap';

const ApparelCollections = () => {
  return (
    <Fragment>
      <Container fluid className='ApparelCollections'>
        <TopNav />
        <Container>
          <ApparelNav />
          <div className='imageSlider'></div>
          <div className='dots'>
            <span className='dot'></span>
            <span className='dot active-dot'></span>
            <span className='dot'></span>
            <span className='dot'></span>
          </div>
          <Collections />
        </Container>
      </Container>
      <MainFooter />
    </Fragment>
  );
};
export default ApparelCollections;
